<template>
	<div class="wrapper_body wrapper_body_block layout-container-box" :style="{active}">
		<div class="title row-title" :style="{paddingLeft:(level*10)+'px'}"  :class="{active}"
		     @click.stop="toggleSection($event)">
      <span :class="{current: block.selected}">
          <span class="icon">
              <inline-svg :src="require(`@/assets/page/img/sidebar/row.svg`)"/>
          </span>
	      Step #{{stepIndex+1}}
<!--          Container  {{ block.attributes.advanced.title || '#' + (index + 1) }}-->
      </span>
			<div class="wrapper_input dash-buttons"
			     :class="{'eye_show': block.responsive ? !block.responsive[view]:false}">
				<!--				                <a class="layers_item_btn lock_btn"-->
				<!--				                   v-tippy :content="page_findOne(row).editLock ? 'Unlock' : 'Lock'"-->
				<!--				                   @click.stop="lockEditElement(row, page_findOne(row).type)">-->
				<!--					                <img src="@/modules/page-editor/src/assets/img/sidebar/lock_icon.svg" alt="">-->
				<!--				                </a>-->
				<a class="layers_item_btn eye_btn" v-tippy :content="'Hide on ' + view"
				   @click.stop="eyeClick(blockId, block.type)">
					<img src="@/modules/page-editor/src/assets/img/sidebar/eye_icon.svg" alt="">
				</a>
			</div>
		</div>
		<div class="sidebar_layout_items_wrpr">
				<!-- CHILDREN -->
			<layout-child v-for="(child, childIndex) in blocks(children)" :level="level+1"
			              class="container-box-child" @activateMe="activateMe"
            :child-id="child.id" :child-index="childIndex" :child="child" />
				<!-- CHILDREN END -->
		</div>
	</div>
</template>

<script>
import {mapGetters} from "vuex";
const LayoutChild = () => import("@/modules/page-editor/src/components/sidebar/layout/layout_child");

export default {
	name: "layout2StepFormStep",
	components: {LayoutChild},
	props: ['blockId', 'index', 'block', 'children', 'stepIndex', 'level'],
	data() {
		return {
			active:false,
		}
	},
	computed:{
		...mapGetters(['page_findOne', 'current_popup', 'page_findChildren', 'page_findChild']),
		view() {
			return this.$store.state.page.view
		},
		basic() {
			return this.block.attributes.basic;
		},

	},
	methods:{
		blocks(ids){
			return this.page_findChildren(ids, !!this.current_popup)
		},
		eyeClick(id, type){
			let getElementResponsive = this.block.responsive || {
				desktop: true,
				mobile: true,
				tablets: true
			};

			getElementResponsive[this.view] = !getElementResponsive[this.view];
			this.$store.dispatch('PAGE_EDIT_FIELD', {id, field: 'responsive', value: getElementResponsive, type});
		},
		toggleSection(ev) {
			// var parent = ev.target.parentElement;
			// parent.classList.toggle('active');
			// ev.target.classList.toggle('active');
			// // var isActive = parent.classList.contains('active');
			this.active = !this.active;
			if(id) this.activateMe({block:this.block, event:ev, stepIndex:this.stepIndex});
		},
		activateMe(ev) {
			// if ()
			this.$store.dispatch('PAGE_EDIT_FIELD', {
				id: parseInt(this.blockId),
				field: 'previewSteps',
				value: this.stepIndex+1,
				type: 'twoStepForm',
				tab: 'basic'
			});

			this.$emit('activateMe', ev)
		},
	}
}
</script>

<style lang="scss" scoped>
.layout-container-box {
	.row-title {
		padding-left: 70px !important;
	}
	.container-box-child {
		padding-left: 100px !important;
	}
}
</style>
